<div class="flex w-full h-full">
  <ng-container *ngIf="filtersLoadingState$ | async as filtersLoadingState">
    <div class="flex flex-col w-full">
      <div class="flex flex-row mb-4 w-full">
        <div
          class="grid grid-cols-3 justify-items-start sbnbDesktop:flex sbnbDesktop:flex-grow"
          *ngIf="appliedFilters$ | async as appliedFilters">
          <hospitable-filters
            class="col-span-3 col-start-1"
            *ngIf="filtersLoadingState === LoadingState.Success"
            [filters]="filters$ | async"
            [appliedFilters]="appliedFilters$ | async"
            (addFilter)="onAddFilter($event)"
            (applyFilter)="onApplyFilter($event)"
            (removeFilter)="onRemoveFilter($event)"
            (clearAllFilters)="onClearAllFilters()"></hospitable-filters>

          <hospitable-loading *ngIf="filtersLoadingState === LoadingState.Pending"></hospitable-loading>

          <hospitable-save-view [metricKey]="MetricKey.Tasks" [appliedFilters]="appliedFilters"></hospitable-save-view>

          <ng-container *ngIf="views$ | async as views">
            <button
              *ngIf="views && views.length > 0"
              (click)="openListViewDialog(views)"
              mat-flat-button
              class="button__small button__text button_add-filter raspberry-darker">
              <span *ngIf="(activeView$ | async) === null">Views</span>

              <span class="flex" *ngIf="activeView$ | async as activeView">
                {{ activeView.name }}

                <span (click)="clearActiveView($event)">
                  <img class="filter__clearable" src="./assets/icons/cancel-smoke.svg" onload="SVGInject(this)" />
                </span>
              </span>
            </button>
          </ng-container>
        </div>

        <div class="flex flex-row-reverse min-w-fit">
          <sbnb-button
            *ngIf="appliedFilters$ | async as appliedFilters"
            label="Export"
            size="mini"
            (clicked)="export(appliedFilters)"></sbnb-button>
        </div>
      </div>

      <div class="flex flex-col">
        <div class="flex flex-col w-full">
          <div class="flex w-full mt-6">
            <mat-tab-group class="w-full">
              <mat-tab class="w-full" [label]="'Details'">
                <ng-container [ngSwitch]="detailsLoadingState$ | async">
                  <ng-container *ngSwitchCase="LoadingState.Pending">
                    <div class="flex items-center justify-center mt-8">
                      <hospitable-loading></hospitable-loading>
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="LoadingState.Success">
                    <ng-container *ngIf="details$ | async as details; else noData">
                      <hospitable-table
                        *ngIf="appliedFilters$ | async as appliedFilters"
                        class="mb-4"
                        [data]="details"
                        (pageChanged)="onDetailsPageChange($event, appliedFilters)"></hospitable-table>
                    </ng-container>

                    <ng-template #noData>
                      <div class="flex items-center justify-center mt-8">
                        <hospitable-page-level-error [message]="'No data found'"></hospitable-page-level-error>
                      </div>
                    </ng-template>
                  </ng-container>

                  <ng-container *ngSwitchCase="LoadingState.Error">
                    <div class="flex items-center justify-center mt-8">
                      <div class="flex">
                        <hospitable-page-level-error></hospitable-page-level-error>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
